import { Button } from 'devextreme-react';
import { useVersionCheck } from '../../../hooks/useVersionCheck';

/**
 * Limpia la Cache Storage del navegador antes de recargar, para que la
 * recarga traiga el index.html y los bundles nuevos y no otra copia vieja.
 */
const reloadToLatestVersion = async () => {
  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch {}
  // Query param para saltar cachés intermedias del index.html (el hash de
  // HashRouter se conserva).
  window.location.replace(`${window.location.pathname}?nocache=${Date.now()}${window.location.hash}`);
};

/**
 * Banner fijo que aparece cuando hay una versión nueva desplegada en el
 * servidor. No se puede descartar: la app quedaría rota igualmente al
 * navegar cuando los bundles viejos ya no existan.
 */
export const UpdateBanner = () => {
  const updateAvailable = useVersionCheck();

  if (!updateAvailable) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        zIndex: 20000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '16px',
        padding: '10px 16px',
        background: '#2c3e50',
        color: '#fff',
        fontSize: '14px',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.25)',
      }}>
      <span>
        Hay una nueva versión de <strong>SynerLab</strong> disponible. Actualice para continuar trabajando sin inconvenientes.
      </span>
      <Button text='Actualizar ahora' type='default' stylingMode='contained' icon='refresh' onClick={reloadToLatestVersion} />
    </div>
  );
};

export default UpdateBanner;
